export default __webpack_public_path__ + "static/media/response.82d4dda0.svg";